import { render, staticRenderFns } from "./ProductTokenList.vue?vue&type=template&id=40148d06&scoped=true"
import script from "./ProductTokenList.vue?vue&type=script&lang=js"
export * from "./ProductTokenList.vue?vue&type=script&lang=js"
import style0 from "./ProductTokenList.vue?vue&type=style&index=0&id=40148d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40148d06",
  null
  
)

export default component.exports